import { ChangeEvent } from 'react';
import {
  FloatingAmountField,
  IFloatingAmountFieldProps,
} from '@coverflex-tech/hypernova';
import {
  MoneyUtils,
  TMoney,
  defaultMoney,
} from '@coverflex-tech/hypernova-utils';

export interface IFloatingMoneyFieldProps
  extends Omit<
    IFloatingAmountFieldProps,
    'onChange' | 'amount' | 'availableAmount'
  > {
  amount?: TMoney | null;
  availableAmount?: TMoney;
  onChange: (amount: TMoney | null) => void;
  currency?: string;
}

export const FloatingMoneyField = ({
  id,
  label,
  amount,
  onChange,
  className,
  onBlur,
  error,
  disabled,
  hint,
  availableAmount,
  availableLabel,
  inline,
  size,
}: IFloatingMoneyFieldProps) => {
  const valueFormatter = (value: string | undefined, focused: boolean) => {
    if (value !== undefined && !focused) {
      return MoneyUtils.moneyToString({
        amount: Number(value),
        currency: amount ? amount.currency : defaultMoney.currency,
      });
    }
    return amount !== undefined && amount !== null
      ? MoneyUtils.moneyToFloat({
          amount: Number(value),
          currency: amount.currency,
        })
      : '';
  };

  const handleChange = (ev: ChangeEvent<HTMLInputElement>) => {
    onChange(
      ev.target.value.length > 0
        ? MoneyUtils.parseString(
            ev.target.value,
            amount ? amount.currency : defaultMoney.currency
          )
        : null
    );
  };

  return (
    <FloatingAmountField
      className={className}
      id={id}
      label={label}
      inline={inline}
      amount={amount?.amount}
      valueFormatter={valueFormatter}
      onChange={handleChange}
      onBlur={onBlur}
      error={error}
      hint={hint}
      disabled={disabled}
      availableAmount={
        availableAmount ? MoneyUtils.moneyToString(availableAmount) : undefined
      }
      availableLabel={availableLabel}
      size={size}
    />
  );
};
